module.exports = __webpack_public_path__ + "static/media/Vidhii.43f22bb0.png";